import fetchWithSmimeHeaders from './fetchWithSmimeHeaders';
import SmimeCustomError from '../utils/SmimeCustomError';
import { DatapointStatus, PerformanceDatapoint } from 'owa-analytics';
import { AttachmentId } from 'owa-attachment-well-data';
import { getDefaultRoutingKey } from 'owa-client-ids';
import { AttachmentUrlType, getAttachmentUrlForClassic } from 'owa-files-url';
import SmimeErrorStateEnum from 'owa-smime-adapter/lib/store/schema/SmimeErrorStateEnum';
import * as trace from 'owa-trace';

/**
 * This function fetches the ItemAttachmentPackage given the url
 * @param url URL to fetch ItemAttachmentPackage
 * @param asDataUri FileAttachments need to be fetched as dataUri while Mail items do not
 */
const fetchAttachmentContent = async (
    AttachmentId: AttachmentId,
    asDataUri?: boolean
): Promise<string> => {
    const fetchDataDatapoint = new PerformanceDatapoint('FetchAttachmentContent', {
        isCore: true,
    });
    const url = getAttachmentUrlForClassic(
        getDefaultRoutingKey(),
        AttachmentId,
        AttachmentUrlType.FullFile
    );
    try {
        const data = await fetchWithSmimeHeaders(`${url}${asDataUri ? '&asDataUri=true' : ''}`);
        fetchDataDatapoint.end();
        return data;
    } catch (error) {
        trace.errorThatWillCauseAlert(
            `SmimeTraceError: FetchAttachmentContent failed. URL: ${url}`
        );
        fetchDataDatapoint.endWithError(DatapointStatus.ServerError, error);
        throw new SmimeCustomError(error.message, SmimeErrorStateEnum.UnknownError);
    }
};

export default fetchAttachmentContent;
